module.exports = __webpack_public_path__ + "static/media/televisa-univision.15ceb347.png";